module.exports = __webpack_public_path__ + "img/jpn.3e72015c.svg";